/**
 * ULID / UUID generation. `client_msg_id` (ULID) is the idempotency key for
 * `msg.send` and mutating REST ops (per contracts notes). ULIDs are
 * lexicographically sortable so they double as a stable client-side order key
 * before the server assigns `seq`.
 */

const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford base32
const ENCODING_LEN = ENCODING.length;
const TIME_LEN = 10;
const RANDOM_LEN = 16;

function randomChar(): string {
  const r = Math.floor(Math.random() * ENCODING_LEN);
  return ENCODING.charAt(r);
}

/** RFC-ish ULID. Monotonicity within a ms is not guaranteed but adequate for UI. */
export function ulid(now: number = Date.now()): string {
  let time = now;
  let out = '';
  for (let i = TIME_LEN - 1; i >= 0; i--) {
    const mod = time % ENCODING_LEN;
    out = ENCODING.charAt(mod) + out;
    time = (time - mod) / ENCODING_LEN;
  }
  for (let i = 0; i < RANDOM_LEN; i++) out += randomChar();
  return out;
}

/** UUID v4 (crypto-backed where available). */
export function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
